import AutocompleteWrapper from '@/components/AutocompleteWrapper/AutocompleteWrapper'
import type { TypeAheadConfigEndpoint } from '@/components/TypeAhead/types'
import logSearchFormAnalytics from '@/shared-utils/log-search-form-analytics'
import { PackageSearchForm } from '@pcln/horizon-search-form'
import type { PackagesFormStateType } from '../types'
import usePackagesFormInitialValues from './usePackagesFormInitialValues'

const DEFAULT_PICKUP_TIME = '12:00'
const DEFAULT_DROPOFF_TIME = '12:00'

export default function HorizonPackagesForm({
  onSubmit,
  pageName,
  useCompactLayout = false,
}: Readonly<{
  onSubmit: (pageName: 'homepage' | 'landing', data: PackagesFormStateType) => void
  pageName: 'homepage' | 'landing'
  useCompactLayout?: boolean
}>) {
  const { initialValues, isMobile, cguid, localeCode } = usePackagesFormInitialValues()

  return (
    <PackageSearchForm
      variant={useCompactLayout ? 'compact' : 'full'}
      initialValues={initialValues}
      isMobile={isMobile}
      autoAdvance={!isMobile}
      localeCode={localeCode}
      pageName={pageName}
      defaultPickupTime={DEFAULT_PICKUP_TIME}
      defaultDropoffTime={DEFAULT_DROPOFF_TIME}
      onSubmit={(data) => {
        try {
          localStorage.setItem('pkgSearchValues', JSON.stringify(data))
        } catch {
          // Ignore storage failures
        }
        onSubmit(pageName, data as PackagesFormStateType)
        logSearchFormAnalytics({ cguid, pageName, productType: 'vacations', isMobile })
      }}
      renderAutocomplete={(props) => (
        <AutocompleteWrapper
          ref={props.inputRef}
          searchKey={props.searchKey}
          label={props.label}
          typeAheadEndpoint={props.typeAheadEndpoint as TypeAheadConfigEndpoint}
          errorMessage={props.errorMessage}
          initialSelectedItem={props.initialSelectedItem}
          onItemSelect={(item) => props.onItemSelect(item)}
        />
      )}
    />
  )
}
